import { basicInitialState } from 'store/_utils/basicInitialState';
import { TProposalsState } from './ProposalsModel';

export const proposalsInitialState: TProposalsState = {
  ...basicInitialState,
  proposals: null
};
